class Siteheader {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-siteheader',
            hiddenClassname: 'siteheader--hidden',
            overlayClassname: 'siteheader--overlay'
        };

        this.settings = Object.assign({}, defaults, options);

        this.$siteheader = element;
        this.eventScroller = window.eventScroller;
    }

    initialize () {
        this.handleVisibility();
        this.setEvents();
    }

    setEvents () {
        this.eventScroller.customFunctions.push(() => {
            this.handleVisibility();
        });
    }

    handleVisibility () {
        const siteheaderHeight = this.$siteheader.offsetHeight;

        if (window.scrollPosition > siteheaderHeight && window.checkForScroll) {
            if (window.scrollDirection === 'down') {
                this.toggleHeader(false, false);
            } else {
                this.toggleHeader(true, true);
            }
        } else {
            this.toggleHeader(true, false);
        }
    }

    toggleHeader (visible, shadow) {
        if (visible === true) {
            if (this.$siteheader.classList.contains(this.settings.hiddenClassname)) {
                this.$siteheader.classList.remove(this.settings.hiddenClassname);

                if (shadow === true) {
                    if (this.$siteheader.classList.contains(this.settings.overlayClassname)) {
                        this.$siteheader.classList.remove(this.settings.overlayClassname);
                    } else {
                        this.$siteheader.classList.add(this.settings.overlayClassname);
                    }
                }
            }
        } else {
            if (!this.$siteheader.classList.contains(this.settings.hiddenClassname)) {
                this.$siteheader.classList.add(this.settings.hiddenClassname);
            }
        }

        if (shadow === false) {
            if (this.$siteheader.classList.contains(this.settings.overlayClassname)) {
                this.$siteheader.classList.remove(this.settings.overlayClassname);
            }
        }
    }
}

export default Siteheader;
